import React from 'react';
import { DefaultMessage } from 'src/model/chat-bot';
import { Button } from 'antd';

interface ActionButtonsProps {
    defaultMessages: DefaultMessage[];
    isInitial: boolean;
    onClick: (msg: DefaultMessage) => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({defaultMessages, isInitial, onClick}) => (
    <>
        <div className="chat-actions-buttons">
            {defaultMessages.map((defaultMessage) => (
                <Button key={defaultMessage.title} className="chat-action-btn" onClick={() => onClick(defaultMessage)}>
                    <div className={'chat-action-icon'}>{defaultMessage.icon}</div>
                    {defaultMessage.title}
                </Button>
            ))}
        </div>
        {isInitial && <span className={'disclaimer'}>
            This AI assistant only saves draft policies. It is the user's responsibility to review any AI-generated policy and confirm
            that it is appropriate for the user's specific business needs before applying.
        </span>}
    </>
);
